<template>
  <div>
    <div class="ticket-list-header flex-r">
      <div
        v-for="item in columns"
        :key="item.key"
        class="ticket-list-th"
        :style="{'width': item.width ? `${item.width}px` : '', 'flex': item.width ? '':'1'}">
        {{item.title}}
      </div>
    </div>
    <div>
      <div class="ticket-list-body flex-c" v-for="(item, index) in list" :key="item.id" v-if="list.length > 0">
        <div class="ticket-list-tr flex-r" style="width: 100%; padding-left: 58px;">
          <div class="ticket-list-td" style="flex: 1;">{{item.displayName}}</div>
          <div class="ticket-list-td" style="flex: 1;">{{item.summary}}</div>
          <div class="ticket-list-td ticket-list-price">
            ￥
            <span style="font-size: 22px;font-weight: 600;">
            {{handlePrice(item)}}
            <span style="font-size: 14px;font-weight: 400">起</span>
          </span>
          </div>
          <div class="ticket-list-td" style="width: 150px;text-align: center;font-size: 16px">
            <div v-if="item.isOpen" class="open-btn" @click="toOpen('up', index)">
              <span>收起</span>
              <Icon type="ios-arrow-up" />
            </div>
            <div v-if="!item.isOpen" class="open-btn" @click="toOpen('down', index)">
              <span>展开</span>
              <Icon type="ios-arrow-down" />
            </div>
          </div>
        </div>
        <div class="ticket-list-tr ticket-list-children flex-r" style="width: 100%; padding-left: 58px;" v-if="item.children && item.isOpen" v-for="(chil, idx) in item.children">
          <div class="ticket-list-td" style="flex: 1;">
            {{chil.displayName}}
            <Button
              class="x-text-btn"
              icon="ios-alert"
              @click="showNeedKnow(chil)"
              type="text">
              购票须知
            </Button>
            <p style="font-size: 12px;">{{item.englishName}}</p>
          </div>
          <div class="ticket-list-td" style="flex: 1; font-size: unset;" v-html="chil.summary"></div>
          <div class="ticket-list-td ticket-list-price">
            ￥
            <span style="font-size: 22px;font-weight: 600;">
              {{handlePrice(chil)}}
            </span>
          </div>
          <div class="ticket-list-td" style="width: 150px;text-align: center;">
            <Button class="to-btn" type="primary" @click="show(chil, idx)">立即购买</Button>
          </div>
        </div>
      </div>
      <div class="ticket-list-message" v-if="list.length === 0">暂无数据</div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
    <!-- 购票须知 -->
    <x-modal :value="needKnowShow" :content="description" @toClose="toClose"></x-modal>
  </div>
</template>

<script>
import xModal from '@/components/xModal/index'
import Vue from "vue";
export default {
  name: 'x-table',
  props: ['columns', 'data'],
  components: {
    'x-modal': xModal
  },
  data () {
    return {
      ids: {},
      list: [],
      needKnowShow: false,
      description: '',
      spinShow: false
    }
  },
  watch:{
    data:{
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          let arr = JSON.parse(JSON.stringify(newVal))
          arr[0].isOpen = true
          this.$set(this, 'list', arr)
        }
        this.spinShow = false
      }
    }
  },
  created() {
    this.spinShow = true
  },
  mounted() {
    let obj = {}
    this.columns.forEach(item => {
      obj[item.key] = item
    })
    this.ids = obj
  },
  methods: {
    showNeedKnow (row) { // 购买须知
      this.description = row.description
      this.needKnowShow = true
    },
    toClose () {
      this.needKnowShow = false
    },
    toOpen(type, index) {
      if (type === 'up') {
        this.list[index].isOpen = false
      } else {
        this.list.forEach((item, idx) => {
          this.$set(this.list[idx], 'isOpen', false)
        })
        this.list[index].isOpen = true
      }
    },

    show (row, index) {
      console.log(Vue.ls.get('type'), row)
      const type = Vue.ls.get('type')
      if (type === '1') {
        this.$router.push({ path: '/purchase/group', query: { id: row.productId } })
      } else {
        this.$router.push({ path: '/purchase/individual', query: { id: row.productId } })
      }
    },
    handlePrice (data) {
      let str = ''
      let dataC = JSON.parse(JSON.stringify(data))
      if (dataC.children) {
        let arr = dataC.children.sort((a, b) => {
          return a.salePrice * 1 - b.salePrice * 1
        })
        str = `${arr[0].salePrice}`
      } else {
        str = `${dataC.salePrice}`
      }
      return str
    },
  }
}
</script>

<style scoped lang="less">
.ticket-list-header{
  padding-left: 58px;
  background: @common;
}
.ticket-list-th{
  padding: 12px 36px;
  color: #fff;
  font-size: 22px;
}
/*.ticket-list-th:nth-of-type(1), .ticket-list-th:nth-of-type(2) {*/
/*  padding-left: 40px;*/
/*}*/
.ticket-list-tr{
  align-items: center;
  border-bottom: solid #ddd 1px;
  min-height: 120px;
}
.ticket-list-td{
  padding: 12px 18px;
  font-size: 18px;
}
  .open-btn{
    color: #EA5E3D;
    cursor: pointer;
  }
  .ticket-list-children{
    background: #F7F7F7;
  }
.x-text-btn{
  color: #ED7457;
  background: transparent !important;
  border: none;
  box-shadow: none;
  padding: 0;
}
.ticket-list-message{
  width: 100%;
  text-align: center;
  line-height: 72px;
}
.to-btn{
  border-radius: 60px;
}
  .ticket-list-price{
    width: 150px;
    color: @common;
  }
</style>
